module.exports = __webpack_public_path__ + "static/media/1.1336c346.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/products/images/16019/1.jpg
// module id = 511
// module chunks = 0